/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { ModalsProvider as NativeModalsProvider } from '@mantine/modals';

// Components
import MessageModal from '../../../shared/components/organisms/MessageModal';
import ErrorModal from '../../../shared/components/organisms/ErrorModal';

/* -------------------------------------------------------------------------- */
/*                                  Provider                                  */
/* -------------------------------------------------------------------------- */

const ModalsProvider = (props) => {
  const { children } = props;

  /* ******************************** RENDERING ******************************* */

  return <NativeModalsProvider modals={{ message: MessageModal, error: ErrorModal }}>{children}</NativeModalsProvider>;
};

export default ModalsProvider;
